import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setParcelsForStagesInStore } from "../../actions/parcels";
import { updateToastInfo } from "../../actions/settings";
import { updateSpinnerState } from "../../actions/spinner";
import ParcelStatusPage from "../../components/common/parcelStatusPages";
import { getParcelsByStatusAndSubStatus } from "../../parse-functions/parcels";
import { Routes } from "../../router/routes";
import { convertArrayToObj } from "../../utils/json";
import { buybackRegisterTableColumns } from "./buybackUtils";
import { setFiltersInStore } from "../../actions/filters";
import { returnEndOfDay, returnStartOfDay } from "../../utils/datetime";


const BuyBackRegisterList = () => {
    const pageReduxKeyName = "buybackRegister";
    const pageStatus = "buybackpending";
    const { t } = useTranslation();

    const breadCrumbItems = [{
        title: t("BuyBack"),
        link: Routes.BuyBack.Pending.path
    }, {
        title: t("BuyBack Received"),
        link: Routes.BuyBack.Received.path
    }];
    const dispatch = useDispatch();

    const [selectedParcelId, setSelectedParcelId] = useState(null);
    const storeCode = useSelector((state) => state?.user?.warehouse?.warehouseCode || "");
    const filtersValue = useSelector((state) => state.filters?.[pageReduxKeyName]);
    const parcels = useSelector((state) => state?.parcels?.[pageReduxKeyName] || {});
    const zone = useSelector((state) => state?.user?.warehouse?.zone || "");
    
    const handleFiltersSubmit = (startDate, endDate) => {
        dispatch(setFiltersInStore({
            pageType: pageReduxKeyName,
            data: {
              startDate: new Date(startDate),
              endDate: new Date(endDate)
            }
          }))
        getAvailableParcels(startDate, endDate);
    };

    const getAvailableParcels = async (startDate, endDate) => {
        dispatch(updateSpinnerState(true));
        try {
            const filters = {
                subStatus: [pageStatus, "buybackpicked", "buybackpickedcashcollected"],
                storeCode,
                startDate: new Date(startDate),
                endDate: new Date(endDate),
                zone
            };
            const parcels = await getParcelsByStatusAndSubStatus(filters);
            dispatch(setParcelsForStagesInStore(pageReduxKeyName, convertArrayToObj(JSON.parse(JSON.stringify(parcels)), "objectId")))
            dispatch(updateSpinnerState(false));
            dispatch(updateToastInfo({
                show: true,
                type: 'success',
                title: t('Orders fetched'),
                message: t("You can mark all your buybacks as received from here")
            }))

        } catch (e) {
            dispatch(updateSpinnerState(false));
            dispatch(updateToastInfo({
                show: true,
                type: 'danger',
                title: t('Error'),
                message: t(e.message)
            }))
        }
    }
    const onRowSelect = (value, objectId) => {
        if (selectedParcelId) {
            dispatch(updateToastInfo({
                show: true,
                type: 'danger',
                title: t('Only 1 item allowed'),
                message: t("Please deselect other item before choosing this")
            }))
        } else {
            if (value) {
                setSelectedParcelId(objectId);
            } else {
                setSelectedParcelId(null);
            }
        }
    }
    const onRefreshClick = () => {
        const currentStartDate = filtersValue.startDate ? new Date(filtersValue.startDate): returnStartOfDay(new Date());
        const currentEndDate = filtersValue.endDate ? new Date(filtersValue.endDate) : returnEndOfDay(new Date());
        getAvailableParcels(currentStartDate, currentEndDate)
    }
    
    const printChallanDetails = async () => {
        // write code to go to new page and print the challan
        window.open(`${window.location.origin}/challan/print/${selectedParcelId}`, "_blank")
    };
    const handleItemBulkUpdate = (actionId) => {
        if (selectedParcelId) {
            switch (actionId) {
                case "print": {
                    printChallanDetails();
                    break;
                }
                default: {
                    dispatch(updateToastInfo({
                        show: true,
                        type: 'danger',
                        title: t('Select an Action'),
                        message: t("Please select an action from the dropdown")
                    }))
                    break;
                }
            }
        } else {
            dispatch(updateToastInfo({
                show: true,
                type: 'danger',
                title: t('Select Item'),
                message: t("Please select an item to take action")
            }))
        }
    }
    return (
        <>
            <ParcelStatusPage
                pageType={pageStatus}
                filtersValue={filtersValue}
                filterSubmit={handleFiltersSubmit}
                tableData={parcels}
                tableColumns={buybackRegisterTableColumns(onRowSelect)}
                handleRefresh={onRefreshClick}
                pageTitle={t("Buyback Register")}
                breadCrumbItems={breadCrumbItems}
                pageSubTitle={t("Use this to print the Challan for the buybacks that have been rescheduled")}
                searchPlaceHolder={t("Search by Invoice No. in Database")}
                handleItemBulkUpdate={handleItemBulkUpdate}
                bulkActionOptions={[{
                    label: "Print",
                    value: "print"
                }]}
                enableBulkActions={selectedParcelId && Object.keys(parcels)?.length > 0}
            />
        </>
    )
}
export default BuyBackRegisterList;